<template>
  <div v-if="analytic" class="gp-content">
    <content-tab-bar :tabs="tabs"></content-tab-bar>
    <transition name="fade" mode="out-in">
      <router-view :analytic="analytic"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContentTabBar from '@/components/ContentTabBar.vue';

export default {
  name: 'Analytic',
  components: { ContentTabBar },
  computed: {
    ...mapState('primary', ['analytic']),
    ...mapState('route', ['name']),
    tabs() {
      const tabs = [
        {
          label: 'Summary',
          link: {
            name: 'analytics.index.detail',
            params: { id: this.analytic.uuid },
          },
          icon: 'logic',
        },
      ];

      if (!this.analytic.digita) {
        tabs.push({
          label: 'Edit',
          link: {
            name: 'analytics.index.detail.edit',
            params: { id: this.analytic.uuid },
          },
          icon: 'edit',
        });

        tabs.push({
          label: 'Delete',
          link: {
            name: 'analytics.index.detail.delete',
            params: { id: this.analytic.uuid },
          },
          icon: 'delete',
        });
      } else {
        tabs.push({
          label: 'Copy',
          link: {
            name: 'analytics.index.create',
            query: { b: this.analytic.uuid },
          },
          icon: 'copy',
        });
      }
      return tabs;
    },
  },
  async beforeMount() {
    await this.$store.dispatch('primary/getAnalytic', {
      uuid: this.$route.params.id,
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

</style>
